<template>
  <div>
    <Card shadow>
      <Row :gutter="24">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platid"
              filterable
              placeholder="选择APP分组"
              clearable
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}<span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              :disabled="!table.params.platid"
              filterable
              placeholder="选择APP盘口"
              clearable
            >
              <Option
                v-for="(item, index) in app_list.filter(
                  item => item.platform == table.params.platid
                )"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName
                }}<span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">玩家ID:</span>
            <Input
              v-model="table.params.uid"
              placeholder="搜索 玩家ID"
              clearable
            ></Input>
          </label>
        </Col>
        <!-- <Col span="3">
                    <Input v-model="table.params.nick_name" placeholder="搜索 玩家昵称" clearable></Input>
                </Col> -->
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">操作人:</span>
            <Input
              v-model="table.params.puid"
              placeholder="搜索  操作人"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span style="width: 95px">信息筛选时间:</span>
            <DatePicker
              type="daterange"
              v-model="select.dataTime"
              placeholder="信息筛选时间"
              :options="dateOptions"
            ></DatePicker>
          </label>
        </Col>
        <Col span="5">
          <Button type="primary" @click="getUserRiskList(1)">查询</Button>
          <Button type="info" @click="ModalShow()" style="margin-left: 10px"
            >赠送红包</Button
          >
        </Col>
      </Row>
      <Row :gutter="24" style="margin-top: 10px">
        <Col span="24">
          <span style="line-height: 28px"
            >统计人数：{{ table.summary.user_num }}人</span
          >&nbsp;&nbsp;
          <span style="line-height: 28px"
            >总计赠送金额：{{
              (table.summary.pack_sum / 10000).toFixed(2)
            }}元</span
          >&nbsp;&nbsp;
          <span style="line-height: 28px"
            >领取总金额：{{
              (table.summary.recive_sum / 10000).toFixed(2)
            }}元</span
          >
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 10px"
      :max-height="tableMaxHeight"
    ></Table>
    <Page
      v-show="table.data.length"
      style="margin-top: 10px"
      :current="table.params.page"
      :total="table.total"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.page_size"
      show-sizer
      show-total
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>

    <Modal v-model="setModal.show" width="500" @on-cancel="CloseModal">
      <div slot="header">赠送红包</div>
      <Form
        :ref="setModal.ref"
        :model="setModal.params"
        :rules="setModal.rules"
        :label-width="120"
      >
        <Row>
          <Col span="20">
            <FormItem label="所属分组" prop="platid">
              <Select
                v-model="setModal.params.platid"
                filterable
                placeholder="选择APP分组"
                clearable
              >
                <Option
                  v-for="(item, index) in plat_list"
                  :value="item.id"
                  :label="item.name"
                  :key="index"
                >
                  {{ item.name
                  }}<span style="color: #bbb">({{ item.id }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="所属盘口" prop="app_id">
              <Select
                v-model="setModal.params.app_id"
                :disabled="!setModal.params.platid"
                filterable
                placeholder="选择APP盘口"
                clearable
              >
                <Option
                  v-for="(item, index) in app_list.filter(
                    item => item.platform == setModal.params.platid
                  )"
                  :value="item.appid"
                  :label="item.appName"
                  :key="index"
                >
                  {{ item.appName
                  }}<span style="color: #bbb">({{ item.appid }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="红包类型" prop="pack_type">
              <Select
                v-model="setModal.params.pack_type"
                placeholder="红包类型"
                clearable
              >
                <Option
                  v-for="(item, index) in select.redType_list"
                  :value="item.value"
                  :label="item.name"
                  :key="index"
                >
                  {{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="玩家ID" prop="uid">
              <Input
                v-model="setModal.params.uid"
                placeholder="玩家ID"
                clearable
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="红包金额" prop="user_tag">
              <InputNumber
                v-model="setModal.params.pack_point"
                placeholder="红包金额"
                style="width: 100%"
                :min="0"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label=" 操作备注" prop="user_tag">
              <Input
                v-model="setModal.params.desc"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="操作备注"
              />
              <!-- <InputNumber v-model="setModal.params.pack_point" placeholder="红包金额" style="width:100%;"></InputNumber> -->
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="CloseModal()">关闭</Button>
        <Button type="warning" @click="Update()">提交</Button>
      </div>
    </Modal>

    <Modal v-model="setModal.showtwo" width="500">
      <div slot="header">赠送红包</div>
      <Form :model="setModal.params" :label-width="120">
        <Row>
          <Col span="20">
            <FormItem label="所属分组:">
              <span>{{ setModal.platidName }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="所属盘口:">
              <span>{{ setModal.app_idName }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="红包类型:">
              <span>{{ setModal.resName }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="玩家ID:">
              <span>{{ setModal.params.uid }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="红包金额:">
              <span>{{ setModal.params.pack_point }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="操作备注:">
              <span>{{ setModal.params.desc }}</span>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="setModal.showtwo = false">取消</Button>
        <Button type="warning" @click="SendReward()">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { SendRewardpack, GetRewardpackList } from '@/api/admin/player'
export default {
  name: 'redEnvelope',
  data() {
    return {
      tableMaxHeight: 0,
      select: {
        dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()],
        redType_list: [
          { name: '新手红包', value: 1 },
          { name: '恭贺红包', value: 2 },
          { name: '鼓励红包', value: 3 }
        ]
      },
      //表单数据
      table: {
        params: {
          platid: 0,
          app_id: 0,
          page: 1,
          page_size: 10,
          nick_name: '',
          puid: null,
          uid: '',
          stime: 0,
          etime: 0
        },
        data: [],
        columns: [
          {
            title: '所属平台',
            key: 'platid',
            minWidth: 80,
            align: 'center',
            render: (h, params) => {
              let arr = []
              let app_info = this.getPlatInfo(params.row) || {}
              if (app_info) {
                arr.push(
                  h('span', app_info.name),
                  h('span', { style: 'color:#bbb' }, `（${app_info.id}）`)
                )
              } else {
                arr.push(
                  h('span', { style: 'color:#ed4014' }, `未找到指定平台`)
                )
              }
              return h('div', arr)
            }
          },
          {
            title: '所属盘口',
            key: 'app_id',
            minWidth: 90,
            align: 'center',
            render: (h, params) => {
              let arr = []
              let app_info = this.getAppInfo(params.row) || {}
              if (app_info) {
                arr.push(
                  h('span', app_info.appName),
                  h('span', { style: 'color:#bbb' }, `（${app_info.appid}）`)
                )
              } else {
                arr.push(h('span', { style: 'color:#ed4014' }, `未找到指定App`))
              }
              return h('div', arr)
            }
          },
          { title: '玩家ID', key: 'uid', align: 'center', minWidth: 70 },
          {
            title: '玩家昵称',
            key: 'nick_name',
            minWidth: 80,
            align: 'center'
          },

          {
            title: '历史转入金额',
            key: 'his_pay',
            minWidth: 80,
            align: 'center',
            render: (h, params) =>
              h('span', (params.row.his_pay / 10000).toFixed(2))
          },
          {
            title: '历史盈亏金额',
            key: 'his_win',
            minWidth: 80,
            align: 'center',
            render: (h, params) =>
              h('span', (params.row.his_win / 10000).toFixed(2))
          },
          {
            title: '红包金额',
            key: 'pack_point',
            minWidth: 80,
            align: 'center',
            render: (h, params) =>
              h('span', (params.row.pack_point / 10000).toFixed(2))
          },
          {
            title: '红包类型',
            key: 'pack_type',
            minWidth: 80,
            align: 'center',
            render: (h, params) => {
              let str =
                this.select.redType_list.find(
                  item => item.value == params.row.pack_type
                ).name || ''
              return h('span', str)
            }
          },
          { title: '赠送时间', key: 'ctime', minWidth: 80, align: 'center' },
          { title: '领取时间', key: 'ptime', minWidth: 80, align: 'center' },
          { title: '操作人', key: 'pname', minWidth: 80, align: 'center' },
          { title: '备注说明', key: 'desc', minWidth: 80, align: 'center' }
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40],
        summary: {
          user_num: 0,
          pack_sum: 0,
          recive_sum: 0
        }
      },

      setModal: {
        show: false,
        showtwo: false,
        ref: 'setModal_form',
        params: {
          platid: 0,
          app_id: 0,
          pack_type: 0,
          uid: '',
          pack_point: 0,
          desc: ''
        },
        rules: {
          platid: this.simpleVerifyItem('请选择所属平台'),
          app_id: this.simpleVerifyItem('请选择所属盘口'),
          pack_type: this.simpleVerifyItem('请选择红包类型'),
          uid: this.simpleVerifyItem('请输入用户ID')
        },
        resName: '',
        platidName: '',
        app_idName: ''
      }
    }
  },
  methods: {
    simpleVerifyItem(message) {
      return [
        {
          required: true,
          trigger: 'blur',
          validator: this.simpleVerify(message)
        }
      ]
    },

    //获取列表
    getUserRiskList(num) {
      if (num) this.table.params.page = 1
      let [stime, etime] = this.select.dataTime
      let params = {
        ...this.table.params,
        stime: this.getSecond(stime) || 0,
        etime: this.getSecond(etime, false) || 0,
        uid: Number(this.table.params.uid)
      }
      GetRewardpackList(params).then(res => {
        this.table.data = res._param.list || []
        this.table.summary.user_num = res._param.user_num || 0
        this.table.summary.pack_sum = res._param.pack_sum || 0
        this.table.summary.recive_sum = res._param.recive_sum || 0
        this.table.total = res._param.total || 0
      })
    },
    //列表分页
    pagechange(page) {
      this.table.params.page = page
      this.getUserRiskList()
    },
    //列表分条
    limitchange(limit) {
      this.table.params.page = 1
      this.table.params.page_size = limit
      this.getUserRiskList()
    },

    ModalShow() {
      this.setModal.params = {
        platid: 0,
        app_id: 0,
        pack_type: 0,
        uid: '',
        pack_point: 0,
        desc: ''
      }
      this.$refs[this.setModal.ref].resetFields()
      this.setModal.show = true
    },
    CloseModal() {
      this.setModal.show = false
    },
    //提交修改，添加菜单
    Update() {
      this.$refs[this.setModal.ref].validate(valid => {
        if (valid) {
          this.setModal.resName =
            this.select.redType_list.find(
              item => item.value == this.setModal.params.pack_type
            ).name || ''
          this.setModal.platidName =
            this.plat_list.find(item => item.id == this.setModal.params.platid)
              .name || ''
          this.setModal.app_idName =
            this.app_list.find(
              item => item.appid == this.setModal.params.app_id
            ).appName || ''
          this.setModal.showtwo = true
          this.CloseModal()
        }
      })
      //
    },
    //赠送红包
    SendReward() {
      let params = {
        ...this.setModal.params,
        uid: Number(this.setModal.params.uid),
        pack_point: this.setModal.params.pack_point * 10000
      }
      SendRewardpack(params).then(res => {
        this.getUserRiskList()
        this.CloseModal()
        this.setModal.showtwo = false
      })
    },
    getAppInfo(item) {
      return this.app_list.find(el => el.appid == item.app_id) || {}
    },
    getPlatInfo(item) {
      return this.plat_list.find(el => el.id == item.platid) || {}
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      this.table.params.app_id = this.app_list.find(
        item => item.platform == this.table.params.platid
      ).appid
      this.getUserRiskList()
    }
  },

  created() {
    this.initFunc()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 300
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
